/**
 * TYT Platform API
 * This is the TYT Platform API. It is used by TYT's apps to interact 
 * with the underlying platform. 
 *
 * NOTE: This file is auto generated. 
 * Do not edit this file manually.
 */

import { BaseModel, Expand, Model, Type } from '../../common';


export interface GiftRedemptionRequest {

    /**
     * Gift redemption code
     */
    redemption_code?: string;

    /**
     * Redemption status of gift
     */
    is_redeemed?: boolean;

    /**
     * The date the gift was redeemed at
     */
    redeemed_at?: string;

    /**
     * Message from redeemer to gifter or sponsor
     */
    message?: string;

    /**
     * Name of the redeemer
     */
    redeemer_name?: string;

}

@Model('GiftRedemption')
export class ApiGiftRedemption extends BaseModel implements GiftRedemptionRequest {

    /**
     * Gift redemption code
     */
    
    
    redemption_code: string;

    /**
     * Redemption status of gift
     */
    
    
    is_redeemed: boolean;

    /**
     * The date the gift was redeemed at
     */
    
    
    redeemed_at: string;

    /**
     * Message from redeemer to gifter or sponsor
     */
    
    
    message: string;

    /**
     * Name of the redeemer
     */
    
    
    redeemer_name: string;

}
